import React, { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';

import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import ListView from '../Common/ListView.react';
import AssignmentListItem from './AssignmentListItem';

import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import AssignmentActions from '../../actions/AssignmentActionCreator';
import AssignmentStore from '../../stores/AssignmentStore';
import SuccessSnackbar from '../Common/SuccessSnackbar';

class AssignmentList extends Component {


    constructor() {
        super(...arguments);
        this.state = {
            assignments: [],
            count: 0,
            page: 0,
            limit: 50,
            searchPage: 0,
            searchMode: false,
            searchText: null,
            dialog: {
                open: '',
                value: null,
            },
            loading: false,
            fetchedAll: false,
            showButton: false
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.openAssignDialog = this.openAssignDialog.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.submitDialog = this.submitDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.sort = this.sort.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.search = this.search.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);

        AssignmentStore.addChangeListener(this.onChange);
        AssignmentActions.getAll({limit: this.state.limit});

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        AssignmentStore.removeChangeListener(this.onChange);

        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {

        const isAdmin      = this.context.auth.isAdmin();
        const newEntityUrl = isAdmin ? '/dashboard/assignment/new' : '';
        let dialogProps;

        if (this.state.dialog.open !== '') {
            dialogProps = {open: true, onRequestClose: this.closeDialog};
            let submitButtonLabel = "Submit";
            switch (this.state.dialog.open) {
                case 'assign':
                    dialogProps.title = "Run assignment";
                    submitButtonLabel = "Run";
                    dialogProps.children = <span>Run this assignment now?</span>;
                    break;
                default:
                    console.error('unhandled dialog ' + this.state.dialog.open);
                    dialogProps.open = false;
                    break;
            }
            dialogProps.actions = [
                <FlatButton
                    label="Cancel"
                    onTouchTap={this.closeDialog}
                />,
                <FlatButton
                    label={submitButtonLabel}
                    onTouchTap={this.submitDialog}
                    disabled={this.state.dialog.value === null}
                />
            ];
        }

        return (
            <div ref="assignmentList">
                <ListView
                    title="Assignments"
                    sortOptions={this.props.sortOptions}
                    sortAction={this.sort}
                    searchAction={this.search}
                    items={this.state.assignments}
                    itemDecorator={AssignmentListItem}
                    newEntityUrl={newEntityUrl}
                    itemActions={{assignDialogAction: this.openAssignDialog}}
                    dialog={dialogProps}
                    toggleSearchMode={this.toggleSearchMode}
                >
                    <SuccessSnackbar message="Assignment will be run shortly" />
                </ListView>
                {this.state.loading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        )
    }

    onChange() {
        const assignments = AssignmentStore.getAll();
        if (!!assignments) {
            if (assignments.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({assignments, loading: false});
            } else {
                const mapped = assignments.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedAssignments = mapped.map((el) => assignments[el.index]);
                this.setState({assignments: sortedAssignments, loading: false});
            }
            if (AssignmentStore.fetchedAll()) {
                this.setState({fetchedAll: true});
            }
        }
    }

    openAssignDialog(id) {
        this.openDialog('assign', id);
    }

    openDialog(dialog, value) {
        if (value === undefined) { value = null; }
        this.setState({dialog: {open: dialog, value: value}});
    }

    submitDialog() {
        let close = true;
        switch (this.state.dialog.open) {
            case 'assign':
                AssignmentActions.run(this.state.dialog.value);
                break;
            default:
                console.error('Error: unhandled dialog ' + this.state.dialog.open);
                break;
        }
        if (close) this.closeDialog();
    }

    closeDialog() {
        this.setState({dialog: {open: ''}});
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'dateAdded':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateAdded)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        AssignmentActions.getAll({sort: options.sort});
    }

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            AssignmentActions.getAll({page, limit: this.state.limit});
            this.setState({page, loading: true});
        } else if (!!this.state.searchText) {
            AssignmentActions.search(this.state.searchText, {page, limit: this.state.limit});
            this.setState({searchPage: page, loading: true});
        }
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.assignmentList.clientHeight) {
            this.loadNextPage();
        }
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { AssignmentActions.search(searchText, {limit: this.state.limit}); }, 500);

            if (searchText !== this.state.searchText) {
                this.setState({fetchedAll: false, showButton: false});
            }
            this.setState({searchText, searchPage: 0});
        }
    }

    toggleSearchMode(searchMode) {
        if (!searchMode) {
            this.setState({searchText: null});
        }
        this.setState({searchMode, fetchedAll: false, showButton: false});
    }

}

AssignmentList.defaultProps = {
    sortOptions: [
        { label: "Name", value: 'name' },
        { label: "Created", value: 'dateAdded' }
    ]
};

AssignmentList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default AssignmentList;
